define('features/pcu/widgetOrder',[
  'lib/util/tda.config',
  'webStorage',
  'lib/arrayShuffle'
], function (
  tdaConfig,
  ws,
  arrayShuffle
) {
  var __participant = BATSiteConfig.pcmABTest === 'enabled'; // eslint-disable-line no-undef
  var __orderKey = tdaConfig.tda.code + 'PCM_widget_order';
  var __defaultOrder = []; // Allows the model determine the order
  var __allWidgets = ['kbb', 'chat', 'cad', 'raq', 'fad'];

  if (!__participant) return __defaultOrder;

  if (!ws.getLocalStorage().getItem(__orderKey)) {
    ws.getLocalStorage().setItem(__orderKey, JSON.stringify(arrayShuffle(__allWidgets)));
  }
  return JSON.parse(ws.getLocalStorage().getItem(__orderKey));
});

